import { boolean, object, optional, string } from 'superstruct';

export const careCollectionsConfigSchema = object({
  showCareCollectionFeedbackComponent: optional(boolean()),
  queryTagForCollectionsTopics: optional(string()),
});
